import React, {Component} from 'react'
import './styles.css'
import api from '../../services/api'
import Header from '../../components/header'
import Skeleton from '../../components/skeleton'
import {Link, useHistory} from 'react-router-dom'

const estadoInicial = {
    name: '',
    products: [],
    loading: true,
    pesquisa: ''
}

class Produtos extends Component {
    
    state = {
        ...estadoInicial
    }

    componentDidMount = () => {
        this.getProdutos()
    }

    componentDidUpdate = async (prevProps, prevState) => {
        if(this.state.pesquisa !== prevState.pesquisa){ 
            await this.getProdutosPesquisa(this.state.pesquisa)
        }
    }

    getProdutosPesquisa = async (pesquisa) => {
        await this.setState({products: []})
        await api.get(`produtosadmin/${pesquisa}`, {
        }).then(response => {
            this.setState({products: response.data})
        })
    }

    getProdutos = async () => {
        await api.get(`produtosadmin`, {
        }).then(response => {
            this.setState({products: response.data})
        })
        this.setState({loading: false})
    }

    render(){
        
        return (
            <div>
                
                {this.state.loading && 
                    <Skeleton />
                }
                {!this.state.loading &&
                <div>
                    <section className="page-add">
                        <Header />
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12 col-md-12 col-sm-12">
                                    <div className="page-breadcrumb">
                                        <h2 style={{marginBottom: '3%', marginTop: '3%', textAlign: 'center'}}>Produtos</h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                    <div className="contact-section">
                        <div className="container">
                            <div className="row">
                                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 text-right">
                                    <input className="form-control" type="text" placeholder="pesquise aqui" value={this.state.pesquisa} name="pesquisa" id="pesquisa" onChange = {e => { this.setState({pesquisa: e.currentTarget.value})}} />
                                </div>  
                                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 text-right">
                                    <Link to={{pathname: `/admin/addproduto/0`}}><button className="btn btn-primary" > Adicionar</button></Link>
                                </div>                            
                            </div>
                        </div>
                    </div>

                    <div className="row" id="product-list">
                        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mix all dresses bags">
                            <div className="single-product-item">
                                <div className="row">
                                    <div className="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4 text-center">
                                        <h5>Código</h5>   
                                    </div>
                                    <div className="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4 text-center">
                                        <h5>Nome</h5>
                                    </div>
                                    <div className="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4 text-center">
                                        <h5>Preço</h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row" id="product-list">
                            {this.state.products.map(feed => (
                                <div key={feed.chave} className="col-lg-12 col-md-12 col-sm-12 mix all dresses bags">
                                    <div className="single-product-item">
                                        <div className="row">
                                            <div className="col-lg-4 col-md-4 col-sm-4 text-center">
                                                <Link to={{pathname: `/admin/addproduto/${feed.chave}`, state: feed.chave}}>
                                                    <p>{feed.chave}</p>
                                                </Link>
                                            </div>
                                            <div className="col-lg-4 col-md-4 col-sm-4 text-center">
                                                <h6>{feed.Descricao}</h6>
                                            </div>
                                            <div className="col-lg-4 col-md-4 col-sm-4 text-center">
                                                <h6>{feed.Preco_Venda.toLocaleString('pt-br', {style: 'currency', currency: 'BRL'})}</h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                    </div>
                </div>
                }                
                
            </div>
        )
        
    }
}

export default Produtos

/*
                {this.state.loading &&
                    <Skeleton />
                }
                {!this.state.loading &&
                <div>
*/
